/**
 * Sellvago brand logo component.
 *
 * variant:
 *   - "primary"   → full lockup with "Sell | Earn | Grow" tagline (hero / footer)
 *   - "secondary" → wordmark only (nav / header where space is tight)
 *   - "submark"   → triangle "A" icon only (favicon / avatar / small badge)
 *   - "b2c"       → sellvago wordmark with "TREVIA" sub-brand
 *
 * tone:
 *   - "dark"  → dark-red wordmark + navy tagline (for LIGHT backgrounds) [default]
 *   - "light" → mint wordmark + mint tagline (for DARK backgrounds)
 *   - "red"   → red submark (submark variant only)
 *   - "navy"  → navy submark (submark variant only)
 */
const HEIGHTS = {
  primary: 44,
  secondary: 32,
  submark: 40,
  b2c: 44,
};

const MAP = {
  "primary-dark":   "/logos/sellvago-primary-dark.png",
  "primary-light":  "/logos/sellvago-primary-light.png",
  "secondary-dark": "/logos/sellvago-secondary-dark.png",
  "secondary-light":"/logos/sellvago-secondary-light.png",
  "submark-red":    "/logos/sellvago-submark-red.png",
  "submark-navy":   "/logos/sellvago-submark-navy.png",
  "submark-light":  "/logos/sellvago-submark-light.png",
  "b2c-dark":       "/logos/sellvago-b2c-dark.png",
  "b2c-light":      "/logos/sellvago-b2c-light.png",
};

export const FarevaultLogo = ({ compact = false, className = "" }) => (
  <span className={`inline-flex flex-col leading-none select-none ${className}`} data-testid="farevault-logo">
    <span
      className={`font-black tracking-tight text-white uppercase ${compact ? "text-xl" : "text-2xl md:text-3xl"}`}
      style={{ fontFamily: "'Chivo', 'Inter', sans-serif", letterSpacing: "-0.02em" }}
    >
      Fare<span className="text-[#00E5FF]">vault</span>
    </span>
    <span className="text-[9px] uppercase tracking-[0.3em] text-[#E8767A] font-bold mt-1 ml-0.5">by Sellvago</span>
  </span>
);

export const Logo = ({ variant = "secondary", tone = "dark", height, className = "" }) => {
  const key = `${variant}-${tone}`;
  const src = MAP[key] || MAP[`${variant}-dark`];
  const h = height ?? HEIGHTS[variant] ?? 36;
  return (
    <img
      src={src}
      alt="Sellvago"
      height={h}
      style={{ height: h, width: "auto" }}
      className={`select-none ${className}`}
      data-testid={`logo-${variant}-${tone}`}
      draggable={false}
    />
  );
};

export default Logo;
